import * as React from 'react';
import { IconProps } from '../types';

const IcMenuClockOut = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      fill={props?.fill ?? '#232F3E'}
      fillRule="evenodd"
      d="M3.5 3h12.214v1.708H4.978v14.584h10.736V21H3.5V3Zm13.737 3.59 4.263 5.175-4.263 5.174-1.523-1.41 2.524-2.675H8.813v-2.03h9.424L15.816 8l1.42-1.41Z"
      clipRule="evenodd"
    />
  </svg>
);

export default IcMenuClockOut;
